import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';

interface Language {
  label: string;
  value: string;
}

@Component({
  selector: 'app-auth-header',
  templateUrl: './auth-header.component.html',
  standalone: true,
  imports: [FormsModule],
})
export class AuthHeaderComponent {
  private translocoService = inject(TranslocoService);

  languages: Language[] = [
    { label: 'EN', value: 'en' },
    { label: 'FR', value: 'fr' },
    { label: 'NL', value: 'nl' },
    // { label: 'DE', value: 'de' }, // Temporarily hidden
  ];

  selectedLanguage: string = 'en';

  constructor() {
    const currentLang = this.translocoService.getActiveLang();
    this.selectedLanguage = currentLang || 'en';
  }

  onLanguageChange(selectedLang: string): void {
    this.selectedLanguage = selectedLang;
    this.translocoService.setActiveLang(selectedLang);
    localStorage.setItem('selectedLanguage', selectedLang);
  }
}
